// extracted by mini-css-extract-plugin
export var compactFilters = "_cz-4";
export var detailImage = "_cz-1";
export var dropdownContainer = "_cz-2";
export var imageContainer = "_cz-0";
export var selectedCard = "_cz-3";